import { Button } from '../ui/button';
import { ArrowRight } from 'lucide-react';
import { WA_URL } from '../../lib/wa';

export const Header = () => (
  <header className="border-b border-gray-100 sticky top-0 bg-white/80 backdrop-blur-md z-50">
    <div className="container mx-auto px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="flex flex-col leading-tight">
          <span className="text-2xl font-bold text-gray-900">Atlas</span>
          <span className="text-xs text-gray-500 font-medium">by Box of India</span>
        </div>
        <nav className="hidden md:flex items-center space-x-8">
          <a href="#why-atlas" className="text-gray-600 hover:text-[#004aad] transition-colors">Why Atlas</a>
          <a href="#how-we-launch" className="text-gray-600 hover:text-[#004aad] transition-colors">How We Work</a>
          <a href="#reach" className="text-gray-600 hover:text-[#004aad] transition-colors">Our Reach</a>
          <a href="#contact" className="text-gray-600 hover:text-[#004aad] transition-colors">Contact</a>
        </nav>
        <Button asChild className="bg-[#004aad] hover:bg-[#003a8c] text-white transition-all duration-300" data-testid="header-get-started-btn">
          <a href={WA_URL} target="_blank" rel="noopener noreferrer">
            Get Started
            <ArrowRight className="ml-2 h-4 w-4" />
          </a>
        </Button>
      </div>
    </div>
  </header>
);
